import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

import { BonusType } from '../models/bonus-type';
import { CitySizeType } from '../models/city-size-type';
import { MenuOption } from '../models/menu-option';
import { RadioInput } from '../models/radio-input';
import { RatingType } from '../models/rating-type';
import { TailCoverageType } from '../models/tail-coverage-type';

@Component({
    selector: 'lib-scorecard-carousel',
    templateUrl: './scorecard-carousel.component.html',
    styleUrls: ['./scorecard-carousel.component.scss'],
    standalone: false
})
export class ScorecardCarouselComponent {

  @ViewChild('tabs') tabs: ElementRef;

  @Input() disabled: boolean = false;
  @Input() errors: Map<string, string> = new Map<string, string>();
  @Input() ratings: Map<string, RatingType> = new Map<string, RatingType>();
  @Input() trackingIdPostfix: string | null = null;
  @Input() trackingIdPrefix: string | null = null;

  @Output() calculateRating = new EventEmitter<MenuOption>();

  bonusType: FormControl<BonusType> = new FormControl<BonusType>(BonusType.Wrvu);
  BonusTypes = BonusType;
  citySizeType: FormControl<CitySizeType | null> = new FormControl(null);
  currentSlide: number = 0;
  tailCoverageType: FormControl<TailCoverageType | null> = new FormControl(null);

  changeRadios(newRadioValue: RadioInput) {
    this.calculate({
      [newRadioValue.name]: newRadioValue.value,
    });
  }

  calculate(sectionValues: any): void {
    this.calculateRating.emit(sectionValues);
  }

  updateSlide(index: number): void {
    this.currentSlide = index;

    const tabs = this.tabs.nativeElement;
    const totalTabs = tabs.querySelectorAll('.tab') as NodeList;
    const currentTab = tabs.querySelector(`.tab--${index}`);
    const centerOffset = (tabs.clientWidth - currentTab.offsetWidth) / 2;

    tabs.scrollLeft = currentTab.offsetLeft - centerOffset;

    if (index === 0) {
      tabs.classList.add('overflow-right');
      tabs.classList.remove('overflow-left');
    } else if (index >= totalTabs.length - 1) {
      tabs.classList.add('overflow-left');
      tabs.classList.remove('overflow-right');
    } else {
      tabs.classList.add('overflow-right');
      tabs.classList.add('overflow-left');
    }
  }

}
